<template>
  <Collapse :active="fieldErrors.length > 0" :duration="150">
    <div class="p-1 text-xs text-red-600 form-error">
      <div v-for="error in fieldErrors" :key="error.rule">
        {{ error.message }}
      </div>
    </div>
  </Collapse>
</template>

<script>
  export default {
    name: 'Validations',

    props: {
      errors: {
        type: Array
      },

      field: {
        type: String
      }
    },

    computed: {
      fieldErrors () {
        return this.errors.filter(err => err.field === this.field)
      }
    }
  }
</script>
